// Entry point for the build script in your package.json
import "@hotwired/turbo-rails"
import "chartkick/chart.js"
import { Chart } from "chart.js"

Chart.register({
  id: "todayLine",
  afterDraw(chart) {
    if (!chart.options.plugins?.todayLine?.enabled) return
    const { ctx, chartArea, scales } = chart
    if (!scales.x) return
    const x = scales.x.getPixelForValue(Date.now())
    if (x < chartArea.left || x > chartArea.right) return
    ctx.save()
    ctx.beginPath()
    ctx.moveTo(x, chartArea.top)
    ctx.lineTo(x, chartArea.bottom)
    ctx.lineWidth = 2
    ctx.strokeStyle = "rgba(245, 166, 35, 0.8)"
    ctx.setLineDash([5, 5])
    ctx.stroke()
    ctx.restore()
  }
})
import "./controllers"
import LocalTime from "local-time"
LocalTime.start()
import * as ActiveStorage from "@rails/activestorage"
ActiveStorage.start()

import "@37signals/lexxy"
